import { Radio as RadioIcon, Cog, Sparkles } from "lucide-react";

export default function RadioPage() {
  return (
    <div data-testid="radio-page">
      <section className="bg-ink text-white py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="eyebrow eyebrow-on-dark flex items-center gap-3"><RadioIcon className="w-4 h-4" /> Radio en ligne</div>
          <h1 className="font-serif text-4xl lg:text-6xl mt-4 leading-tight tracking-tight">
            Front Uni <span className="text-gold italic font-light">Radio</span>
          </h1>
          <p className="mt-6 text-white/75 max-w-2xl text-lg">
            La radio web de la diaspora congolaise : émissions, podcasts, débats et directs audio.
          </p>
        </div>
      </section>

      <section className="py-24 bg-bone">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-ink/5 rounded-full mb-6">
            <Cog className="w-9 h-9 text-gold-dark animate-spin" style={{ animationDuration: "6s" }} />
          </div>
          <div className="eyebrow text-gold-dark">Bientôt disponible</div>
          <h2 className="font-serif text-4xl lg:text-5xl text-ink mt-4 leading-tight">En développement</h2>
          <div className="divider-gold w-20 mt-6 mx-auto" />
          <p className="mt-6 text-foreground/70 leading-relaxed text-[1.02rem]">
            La grille des programmes et le flux en direct de Front Uni Radio seront disponibles très prochainement.
            Émissions politiques, panels d'experts et débats citoyens en accès libre.
          </p>
          <div className="mt-10 flex items-center justify-center gap-2 text-sm text-foreground/55">
            <Sparkles className="w-4 h-4 text-gold-dark" />
            Restez connecté · Lancement officiel à venir
          </div>
        </div>
      </section>
    </div>
  );
}
